<template>
  <v-theme-provider theme="client" with-background>
    <div class="client-shell">
      <!-- App bar -->
      <header class="client-topbar">
        <div class="brand">
          <img :src="logo" alt="Veridian" class="brand-logo" />
          <span class="brand-name">{{ c.brand }}</span>
        </div>
        <div class="topbar-actions">
          <LanguageSelector />
          <v-btn variant="text" color="white" @click="logout">
            <v-icon start>mdi-logout</v-icon>{{ c.logout }}
          </v-btn>
        </div>
      </header>

      <!-- Active section -->
      <main class="client-content">
        <v-container class="py-6">
          <component :is="sectionComponent" :key="tab" />
        </v-container>
      </main>

      <!-- Bottom navigation -->
      <v-bottom-navigation v-model="tab" color="primary" grow class="client-bottomnav">
        <v-btn value="numbers"><v-icon>mdi-phone</v-icon>{{ c.nav_numbers }}</v-btn>
        <v-btn value="sims"><v-icon>mdi-sim</v-icon>{{ c.nav_sims }}</v-btn>
        <v-btn value="add"><v-icon>mdi-plus-circle-outline</v-icon>{{ c.nav_add }}</v-btn>
        <v-btn value="port"><v-icon>mdi-swap-horizontal</v-icon>{{ c.nav_port }}</v-btn>
      </v-bottom-navigation>
    </div>
  </v-theme-provider>
</template>

<script>
import { defineComponent } from 'vue';
import store from "@/store";
import logo from "@/assets/logo.png";
import LanguageSelector from "@/components/LanguageSelector.vue";
import { cc } from "@/views/client/clientCopy";
import MyNumbersSection from "@/views/client/sections/MyNumbersSection.vue";
import MySimsSection from "@/views/client/sections/MySimsSection.vue";
import AddNumberSection from "@/views/client/sections/AddNumberSection.vue";
import PortStatusSection from "@/views/client/sections/PortStatusSection.vue";

export default defineComponent({
  name: 'ClientShellView',
  components: { LanguageSelector, MyNumbersSection, MySimsSection, AddNumberSection, PortStatusSection },
  data() { return { logo, tab: 'numbers' }; },
  computed: {
    c() { return cc(); },
    sectionComponent() {
      return {
        numbers: 'MyNumbersSection',
        sims: 'MySimsSection',
        add: 'AddNumberSection',
        port: 'PortStatusSection',
      }[this.tab] || 'MyNumbersSection';
    },
  },
  methods: {
    logout() {
      store.commit('setLoggedOut');
      this.$router.push({ path: '/login' });
    },
  },
});
</script>

<style scoped>
.client-shell { min-height: 100vh; background: #F5F7FB; padding-bottom: 64px; }
.client-topbar {
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 20px; background: linear-gradient(90deg, #1565C0, #1867C0); color: #fff;
  position: sticky; top: 0; z-index: 5;
}
.brand { display: flex; align-items: center; gap: 10px; }
.brand-logo { height: 34px; background: #fff; border-radius: 6px; padding: 2px; }
.brand-name { font-size: 1.2rem; font-weight: 700; }
.topbar-actions { display: flex; align-items: center; gap: 8px; }
.client-content { max-width: 980px; margin: 0 auto; }
</style>
